import {Component, OnInit, QueryList, ViewChildren, AfterViewInit} from '@angular/core';
import { MdDialogRef } from '@angular/material';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray, AbstractControl} from '@angular/forms';
import { FinancieraService } from '../../../../services/financiera-service';
import { existsInArrayString } from '../../../../utils/validators/CustomValidators';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-new-entidad-dialog',
  templateUrl: './new-entidad-dialog.component.html',
  styleUrls: ['./new-entidad-dialog.component.scss']
})
export class NewEntidadDialogComponent implements OnInit, AfterViewInit {

  public entidad: any = null;
  isEdit = false;
  titleString = '';
  entityCodes: string[] = [];

  form: FormGroup;

  codigoControl: FormControl;
  focus = false;

  subentidadesError = false;

  @ViewChildren('subEntNombre') subEntNombres: QueryList<any>;
  private subEntNombreSubsc: Subscription = new Subscription();

  constructor(private dialogRef: MdDialogRef<NewEntidadDialogComponent>,
              private formBuilder: FormBuilder,
              private financieraService: FinancieraService) { }

  ngOnInit() {
    this.isEdit = this.entidad !== null;
    this.titleString = this.isEdit ? 'Editar ' : 'Nueva ';

    if (this.isEdit) {
      this.form = this.formBuilder.group({
        nombre: [this.entidad.Nombre, [Validators.required]],
        descripcion: this.entidad.Descripcion,
        subentidades: this.formBuilder.array([]),
      });

      this.entidad.Subentidades.forEach(x => {

        const codigoControl: FormControl = new FormControl({value: x.Codigo, disabled: this.isEdit});
        codigoControl.setValidators([Validators.required]);
        const subentidad = this.formBuilder.group({
          id: [x.ID],
          nombre: [x.Nombre, [Validators.required]],
          codigo: codigoControl,
          descripcion: [x.Descripcion],
          locked: [true],
          visibilidad: [x.Visibilidad]
        });
        this.subentidadesForms.push(subentidad);
      });

    } else {

      this.form = this.formBuilder.group({
        nombre: ['', [Validators.required]],
        descripcion: '',
        subentidades: this.formBuilder.array([])
      });
    }
  }

  ngAfterViewInit() {
    this.subEntNombreSubsc = this.subEntNombres.changes.subscribe(x => {
      if (this.subEntNombres.length > 0 && this.focus) {
        this.subEntNombres.last.nativeElement.focus();
        // evita que se haga focus cuando en realidad no se añadio ninguna entidad
        this.focus = false;
      }
    });
  }

  onSubmit() {
    if (!this.subentidadesForms.controls.length) {
      this.subentidadesError = true;
      return;
    }
    if (this.form.invalid) { return; }
    if (this.isEdit) {
      const payload = {
        EntidadFinanciera: {
          ID: this.entidad.ID,
          Nombre: this.form.value.nombre,
          Descripcion: this.form.value.descripcion
        },
        SubentidadesFinancieras: this.subentidadesForms.controls.map(x => ({
          ID: x.get('id').value,
          Nombre: x.get('nombre').value.toString().trim(),
          Codigo: x.get('codigo').value.toString().trim(),
          Descripcion: x.get('descripcion').value ? x.get('descripcion').value.toString().trim() : '',
          Visibilidad: x.get('visibilidad').value
        })),
      };
      this.financieraService.editarEntidad(payload).subscribe(res => {
        if (res) {
          this.dialogRef.close(true);
        }
      });
    } else {
      const payload = {
        EntidadFinanciera: {
          Nombre: this.form.value.nombre,
          Descripcion: this.form.value.descripcion,
        },
        SubentidadesFinancieras: this.subentidadesForms.controls.map(x => ({
          Nombre: x.get('nombre').value.toString().trim(),
          Codigo: x.get('codigo').value.toString().trim(),
          Descripcion: x.get('descripcion').value ? x.get('descripcion').value.toString().trim() : '',
          Visibilidad: true
        })),
      };
      this.financieraService.crearEntidad(payload).subscribe(res => {
        if (res) {
          this.dialogRef.close(true);
        }
      });
    }
  }

  addSubentidad() {
    const codigoControl: FormControl = new FormControl({value: '', disabled: false});
    codigoControl.setValidators([Validators.required]);
  // , existsInArrayString(this.getCodigos())



    const subentidad = this.formBuilder.group({
      id: [0],
      nombre: ['', [Validators.required]],
      codigo: codigoControl,
      descripcion: [],
      locked: [false],
      visibilidad: [true]
    });
    this.focus = true;
    this.subentidadesForms.push(subentidad);
    this.subentidadesError = false;
  }

  updateCodigoValidation(i) {
    /** A ver... los codigos no pueden repetirse, pero la validacion se hace sobre los codigos ya cargados y no
     * sobre los codigos cargados en campos de subentidades anteriores... por lo que en el momento de escribir un codigo
     * le añadimos un set de validaciones nuevas que incluyen los codigos viejos y los codigos de las subentidades que se encuentran
     * en otros campos
     * */
    // generamos el listado a partir de los codigos del BE
    const codes = [...this.entityCodes];
    // le añadimos los codigos de todas las subentidades
    this.subentidadesForms.controls.forEach((x, subIndex) => {
      // no añadimos el valor del campo que estamos editando
      if (subIndex !== i) {
        // obtenemos el valor del campo y si no esta vacio, lo añadimos
        const value = x.get('codigo').value;
        if (value.trim().length) {
          codes.push(value.trim());
        }
      }
    });
    this.subentidadesForms.at(i).get('codigo').setValidators([Validators.required, existsInArrayString(codes)]);
  }

  trimSubValue(i, path) {
    const value = this.subentidadesForms.at(i).get(path).value;
    if (value && typeof value === 'string' && value.length) {
      this.subentidadesForms.at(i).get(path).setValue(value.trim());
    }
  }

  get nombreEntidad() {
    return this.form.get('nombre');
  }

  get codigo() {
    return this.form.get('codigo');
  }

  get subentidadesForms() {
    return this.form.get('subentidades') as FormArray;
  }

  getSubentidadNombre(i): AbstractControl {
    return this.subentidadesForms.at(i).get('nombre');
  }

  getSubentidadCodigo(i): AbstractControl {
    return this.subentidadesForms.at(i).get('codigo');
  }

  getSubentidadLocked(i): boolean {
    return this.subentidadesForms.at(i).get('locked').value;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/entidades-financieras/new-entidad-dialog/new-entidad-dialog.component.ts